import $ from "jquery";
// https://github.com/thecreation/breakpoints-js
import Breakpoints from 'breakpoints-js';

const overviewRow = {
    target: $('.js-account-overview__row'),
    handleFadeOuts() {
        if (this.target[0].scrollWidth > this.target[0].clientWidth) {
            this.target.parent().addClass('c-account-overview__row--overflow');
        } else {
            this.target.parent().removeClass('c-account-overview__row--overflow');
        }
    },
    scrollIntoView() {
        // reset scrollbar. needed for breakpoint change
        this.target.scrollLeft(0);
        let activeElement = $('.c-account-overview__row__entry--active');
        let viewWidth = this.target.width();
        let targetXCord = activeElement.position().left + activeElement.outerWidth(true) - viewWidth + 5;

        this.target.scrollLeft(targetXCord);
    },
    bindEvents() {
        // maybe do this stuff in an own file
        Breakpoints.on('change', () => {
            this.handleFadeOuts();
            this.scrollIntoView();
        });
    }
};

// DOM ready
$(() => {
    if (overviewRow.target.length) {
        overviewRow.handleFadeOuts();
        overviewRow.scrollIntoView();
        overviewRow.bindEvents();
    }
});

export default overviewRow;
